module.exports = __webpack_public_path__ + "img/06-washu.10816954.png";